import { registerMutation } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
const betaRoot = '/rollouts-app/v2/beta-access-rollout';
export const RolloutsAPI = {
  enrollBeta: request => http.post(`${betaRoot}/enroll`, {
    data: Object.assign({}, request)
  })
};
export const ENROLL_BETA = registerMutation({
  fieldName: 'enrollBeta',
  args: ['rolloutId', 'portalId', 'enrollId', 'enrollType', 'betaAccessType'],
  fetcher: request => RolloutsAPI.enrollBeta(request)
});